enum ValidationErrors {
  // Backend validation errors
  // 1****
  RequiredField = 10001,
  // 2****
  MustBeString = 20001,
  InvalidEmail = 20002,
  InvalidCardNumber = 20003,
  InvalidAccountName = 20004,
  InvalidAccountNumber = 20005,
  InvalidIMPSIFSCCode = 20006,
  InvalidConfimationCode = 20007,
  InvalidPhoneNumber = 20008,
  MustBeStringArray = 20009,
  MustBeMatchNamePattern = 20010,
  MustBeMatchLoginPattern = 20011,
  InvalidWallet = 20012,
  InvalidCardHolderName = 20013,
  MustBeMatchCodePattern = 20014,
  // 3****
  MustBeInteger = 30001,
  MustBePositiveInteger = 30002,
  MustBeFloat = 30003,
  MustBePositiveFloat = 30004,
  MustBeIntegerArray = 30005,
  MustBe1or2 = 30006,
  MustBe1or2or3 = 30007,
  MustBeMultiplied60Integer = 30008,
  MustBeSafeNumber = 30009,
  // 4****
  MustBeISO8601 = 40001,
  MustBeTimestamp = 40002,
  MustBeTimestampWithSec = 40003,
  // 5****
  MustBeBoolean = 50001,
  MustBeBooleanAsString = 50002,
  MustBeBooleanAsNumber = 50003,
  // 6****
  MustBeOneOfSort = 60001,
  MustBeOneOfGetTradesSort = 60002,
  MustBeOneOfGetUsersSort = 60003,
  MustBeOneOfGetWithdrawalsSort = 60004,
  MustBeOneOfGetUsersActionLogsSort = 60005,
  MustBeOneOfSymbolPosition = 60006,
  MustBeOneOfGetPromocodesSort = 60007,
  MustBeOneOfGetActivationsSort = 60008,
  MustBeOneOfPaymentTypes = 60009,
  MustBeOneOfOperationsTypes = 60010,
  MustBeOneOfStatisticSteps = 60011,
  MustBeOneOfPaykassmaWithdrawalActions = 60012,
  MustBeOneOfSocialNetworks = 60013,
  MustBeOneOfGenders = 60014,
  // 7****
  MustBe10Digits = 70001,
  Max32CharactersLong = 70002,
  Max512CharactersLong = 70003,
  Max255CharactersLong = 70004,
  Min10Max100Integer = 70005,
  MustBePasswordLengthChars = 70006,
  Max50CharactersLong = 70007,
  IncorrectLength = 70008,
  // 8****
  FileTooLarge = 80001,
  InvalidFileType = 80002,
  FileIsCorrupted = 80003,
  FileDimensionsExceed = 80004,
  // 9****
  InvalidPaymentTypeId = 90001,
  InvalidFormConfigLabel = 90002,
  InvalidFormConfigName = 90003,
  InvalidFormConfigMin = 90004,
  InvalidFormConfigMax = 90005,
  InvalidFormConfigType = 90006,
  MustBeArray = 90007,
}

export default ValidationErrors
